import { AlertsSmallFill } from '@elliemae/ds-icons';
import React, { useContext } from 'react';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { CalendarWithTimeWheelFooterMessage } from './Styleds.js';

export const CalendarWithTimeWheelFooter: React.ComponentType = () => {
  const {
    props: { pickerFooterMsg, hasError, readOnly, applyAriaDisabled },
    getProps,
  } = useContext(ControlledDateTimePickerContext);
  return pickerFooterMsg !== undefined && hasError ? (
    <CalendarWithTimeWheelFooterMessage
      role="alert"
      data-testid={ControlledDateTimePickerDatatestid.FOOTERS.CALENDAR_TIMEWHEEL}
      getOwnerProps={getProps}
      $readOnlyStyles={readOnly || applyAriaDisabled}
    >
      <AlertsSmallFill
        width={8}
        height={8}
        color={['danger', '900']}
        style={{ marginRight: '0.5rem', marginBottom: '2px' }}
      />
      {pickerFooterMsg}
    </CalendarWithTimeWheelFooterMessage>
  ) : null;
};
